<template>
  <div class="content">
    <div class="left">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <div class="right">
      <img v-if="img" :src="require('../../assets/welcome/' + img.file)" :width="img.width" :height="img.height" class="d-block ma-auto" />
      <slot></slot>
      <div class="footer">
        <div class="position">
          <div v-for="n in steps" :key="n" class="block" :class="{ 'active': n === step }"></div>
        </div>
        <div class="actions">
          <v-btn v-if="step > 1" text @click="$emit('prev')">{{ $t('prev') }}</v-btn>
          <v-btn color="accent" :disabled="disabled" @click="$emit('next')">{{ $t(step === steps ? 'finish' : 'next') }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    img: Object,
    step: Number,
    steps: Number,
    disabled: Boolean
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-flow: row nowrap;
  height: 70vh;
}

.left, .right {
  flex: 1 1 50%;
  padding: 1.5rem;
}

.left {
  background-color: var(--v-accent-base);
  color: white;

  .title {
    font-size: 1.75rem !important;
    margin-bottom: 12vh;
    text-transform: uppercase;
  }

  .description {
    font-size: 1.25rem;
  }
}

.right {
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  > * {
    flex: 0 0 auto;
  }
}

.footer {
  align-items: flex-end;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.block {
  border: 1px solid var(--v-secondary-base);
  display: inline-block;
  height: 1.5rem;
  margin-left: .25rem;
  width: 1.5rem;

  &.active {
    background-color: var(--v-accent-base);
  }
}

.actions {
  flex: 0 0 auto;

  .v-btn + .v-btn {
    margin-left: .5rem;
  }
}
</style>
